module.exports = __webpack_public_path__ + "static/img/rl-logo.9e6a13a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rl-logo.png
// module id = LJCJ
// module chunks = 1